import $ from 'jquery';

import { removeNullInput } from 'stdjs/utilities';

export function getFunctionGroupDataForSaving( $container = null ){

    var $functionGroupRows = null;
    
    if ( $container !== null ){
        $functionGroupRows = $container.find( ".functionGroupRow" );
    } else {
        $functionGroupRows = $( ".functionGroupRow" );
    }
    
    var dataString = "";

    var functionGroupIndex = 0;

    $functionGroupRows.each( function( index, element ){
        var $functionGroupRow = $(element);            

        var functionParentFieldString = "FNGP[" + functionGroupIndex + "]";

        if (dataString !== ""){
            dataString += "&";
        }

        dataString += functionParentFieldString + "[FNGP10_ID]=" + removeNullInput($functionGroupRow.attr("data-fngp")); 
        dataString += "&" + functionParentFieldString + "[FNGP10_ENBL]=" + removeNullInput($functionGroupRow.attr("data-enbl"));

        var $functionGroupOptionRows = $functionGroupRow.find(".functionGroupOptionRow");

        var functionGroupOptionIndex = 0;

        $functionGroupOptionRows.each( function( index, element ){
            var $functionGroupOptionRow = $(element); 

            var functionOptionsParentFieldString = "[OPTIONS][" + functionGroupOptionIndex + "]";

            dataString += "&"; 

            dataString += functionParentFieldString + functionOptionsParentFieldString + "[FNGP20_ID]=" + removeNullInput( $functionGroupOptionRow.attr("data-fngp")); 
            dataString += "&" + functionParentFieldString + functionOptionsParentFieldString + "[FNGP20_ENBL]=" + removeNullInput( $functionGroupOptionRow.attr("data-enbl"));

            functionGroupOptionIndex++;

        });

        functionGroupIndex++;

    });

    return dataString;
}

export function initialiseFunctionGroupAuthorities(){

    $(".functionGroupAuthorityParentContainer" ).on("click", ".functionGroup.dropdown-item", function (event) {
        
        var $item = $(event.target);
        
        if ( !$item.is(".dropdown-item") ){
            $item = $item.closest(".dropdown-item");
        }
        
        var $functionGroupRow = $item.closest(".functionGroupRow");
        var $functionOptionsContainer = $functionGroupRow.find( ".collapseFunctionGroup" );
        
        var value = $item.attr("value");
        
        $functionGroupRow.attr("data-enbl", value);
        
        var $parentDropdown = $item.closest(".dropdown");       
        var $button = $parentDropdown.find(".dropdown-toggle");        
        
        $button.html($item.html());
        
        $button.removeClass("btn-success").removeClass("btn-danger").removeClass("btn-secondary");
        
        if (value === "1" ){
            $button.addClass("btn-success");
        } else if ( value === "0" ){
            $button.addClass("btn-danger");
        }
        
        var $hasOptions = $functionGroupRow.attr("data-has-options");
        
        if ( $hasOptions !== "0" ){
        
            var $functionGroupExpandIcon = $functionGroupRow.find(".functionGroupExpandIcon");
            var $functionGroupCollapseIcon = $functionGroupRow.find(".functionGroupCollapseIcon");
            var $functionGroupIconSpacer = $functionGroupRow.find(".functionGroupIconSpacer");

            if ( value === "1" ){
                $functionOptionsContainer.collapse("show");
                $functionGroupExpandIcon.hide();
                $functionGroupCollapseIcon.show(); 
                $functionGroupIconSpacer.removeClass("d-inline-block").hide();
            } else {
                $functionOptionsContainer.collapse("hide");
                $functionGroupExpandIcon.hide();
                $functionGroupCollapseIcon.hide();
                $functionGroupIconSpacer.addClass("d-inline-block").show();
            }      
        }
    });        
    
    $(".functionGroupAuthorityParentContainer" ).on("click", ".functionGroupOption.dropdown-item", function (event) {
        
        var $item = $(event.target);
        
        if ( !$item.is(".dropdown-item") ){
            $item = $item.closest(".dropdown-item");
        }
        
        var $functionGroupOptionRow = $item.closest(".functionGroupOptionRow");
        
        var value = $item.attr("value");
        
        $functionGroupOptionRow.attr("data-enbl", value);
        
        var $parentDropdown = $item.closest(".dropdown");       
        var $button = $parentDropdown.find(".dropdown-toggle");        
        
        $button.html($item.html());
        
        $button.removeClass("btn-success").removeClass("btn-danger").removeClass("btn-secondary");
        
        if (value === "1" ){
            $button.addClass("btn-success");
        } else if ( value === "0" ){
            $button.addClass("btn-danger");
        }
                                    
    });
        
    $(".functionGroupAuthorityParentContainer" ).on("click", ".functionGroupExpandIcon", function (event){
        
        var $item = $(event.target);
        
        var $functionGroupRow = $item.closest(".functionGroupRow");
        var $functionOptionsContainer = $functionGroupRow.find( ".collapseFunctionGroup" );
        var $functionGroupExpandIcon = $functionGroupRow.find(".functionGroupExpandIcon");
        var $functionGroupCollapseIcon = $functionGroupRow.find(".functionGroupCollapseIcon");        
        
        $functionOptionsContainer.collapse("show");
        $functionGroupExpandIcon.hide();
        $functionGroupCollapseIcon.show();            
    });
    
    $(".functionGroupAuthorityParentContainer" ).on("click", ".functionGroupCollapseIcon", function (event){
        
        var $item = $(event.target);
        
        var $functionGroupRow = $item.closest(".functionGroupRow");
        var $functionOptionsContainer = $functionGroupRow.find( ".collapseFunctionGroup" );
        var $functionGroupExpandIcon = $functionGroupRow.find(".functionGroupExpandIcon");
        var $functionGroupCollapseIcon = $functionGroupRow.find(".functionGroupCollapseIcon");        
        
        $functionOptionsContainer.collapse("hide");
        $functionGroupExpandIcon.show();
        $functionGroupCollapseIcon.hide();            
    });
    
}
